
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });

  // relocate warranty from product description to warranty tab
  $( ".warranty-info" ).appendTo( ".warranty-tab" );

  // clone hero-btn for relocation on mobile
  $( ".btn-hero" ).clone().appendTo( ".hero-description" );

  // clone ymm-nextopia for relocation on mobile
  $( ".results-tools" ).clone().appendTo( ".main-panel-body" );

  // relocate no results nextopia template to full col div
  $( ".no-results-info" ).appendTo( ".search-results-footer" );

  // relocate tawk.to widget to sticky footer
  $( "#wMfKDxE-1539807165184" ).clone().appendTo( ".btn-contact-us" );

  //remove logout link text and replace with an icon
  $('a#customer_logout_link').html('<i class="fa fa-sign-out"></i>');

  //remove login link text and replace with an icon
  $('a#customer_login_link').html('<i class="fa fa-user"></i>');

  //add a title attribute to the account login link
  $('a#customer_login_link').attr('title','Account Login');

  //add a title attribute to the logout link
  $('a#customer_logout_link').attr('title','Log Out');

  //remove login link text and replace with an icon
  $('a#customer-link-link').html('<i class="fa fa-user"></i>');

  //add a title attribute to the account link
  $('a#customer-link-link').attr('title','Account');

  // clone utility for relocation on mobile
  $( ".utility-header" ).clone().appendTo( ".mobile-utility-box" );

// If the Slick-slider is loaded, disable slides

var checkExist = setInterval(function() {
    if ($('#ProductThumbs-product-template .slick-list .slick-track').length) {
        $('#ProductThumbs-product-template .slick-list .slick-track').css("transform", "none");
        clearInterval(checkExist);
    }
 }, 100);

var checkVideo = setInterval(function() {
  if ($('.fancybox-slide video').length) {
//    $('.fancybox-slide video').attr("autoplay", "false");
    $('.fancybox-slide video source').attr("autostart", "false");
  }
}, 100);

// Show/Hide Zoom Images 
$('.product-single__featured').css('display','none');
$('.product-single__featured').eq(0).css('display','flex');

// $('.second').children().eq(index);

// function show_hide_video(){
//     var checkShow = true;  
//     $(".product-single__thumbnail-item.images").each(function() {
//         if ($(this).hasClass('is-active')) {
//             checkShow = false; 
//         }
//     });
    
//     if (checkShow == true){
//         console.log('-------Video is showing');
//         $('.product-single__photo a.product-single__thumbnail.product-single__thumbnail-product-template').css('display','block');
//         $('.product-single__photo #ProductPhotoLink-product-template').css('display','none');
//     }
//     else{
//         console.log('-------Video is hidden');
//         $('.product-single__photo #ProductPhotoLink-product-template').css('display','block');
//         $('.product-single__photo a.product-single__thumbnail.product-single__thumbnail-product-template').css('display','none');
//     } 
    
// }

// $(".product-single__thumbnail-item").click(function(){
//     show_hide_video();
// })


$('.product-single__thumbnail-item').click(function() {
    $(".product-single__thumbnail-item").removeClass("is-active");
    $(this).addClass("is-active");  // Add/remove 'is-active' class for thumbnails
    
    var index = $(this).index(); 
    $('.product-single__featured').css('display','none');  //Hide inactive images
    $('.product-single__featured').eq(index).css('display','flex'); //Show active image

    if ($('video').length){
      $( "video" ).each(function() {
        this.pause();
      });
    }
      
});

//Removing fancybox from thumbnails
$(".product-single__thumbnail-item a").removeAttr("href");

if ($('video').length){

  $("video").each(function(){
  //  $(this).attr("autoplay", "false");
  })

  $(".product-single__featured video source[type='video/mp4']").each(function(){
    $(this).attr("autostart", "false");
    $(this).parents("a").attr("href", $(this).attr("src"));

  });
}
  //Inactive video pause
  $( "body" ).click(function( event ) {
    if (event.target.nodeName != null){
      //player.pauseVideo();
      if ($('video').length){
        $( "video" ).each(function() {
          this.pause();
        });
      }
    }
  });

  var player;

  $(".product-single__featured iframe").attr('id', 'featured_video');
  // this function gets called when API is ready to use
  function onYouTubePlayerAPIReady() {

      // create the global player from the specific iframe (#video)
      player = new YT.Player('featured_video', {
          events: {
              // call this function when player is ready to use
              'onReady': onPlayerReady
          }
      });
  }

  function onPlayerReady(event) {

      // var pauseButton = document.getElementById("pause-button");
      // pauseButton.addEventListener("click", function() {
      //     player.pauseVideo();
      // });
  }

  // Inject YouTube API script
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/player_api";
  document.head.appendChild(tag);


// FNF Compatability Button Sidebar Product Page
// THIS WAS REMOVED